import capVerifierActions from "./actions";

const initialState = {
  capVerifiers:[],
  capVerifier:[],
};

const capVerifierReducer = (state = initialState, action) => {
  switch (action.type) {
 
 
    case capVerifierActions.SET_CAP_VERIFIER:
          return {
          ...state,
          capVerifier: action.payload
        };  

    default:
      return state;
  }
};

export default capVerifierReducer;